import React from "react";
import "./button.css";
function BtnOutline(props) {
  const {
    onClick = () => {},
    title = "",
    disabled = false,
    type = "button",
  } = props;
  return (
    <div>
      <button
        onClick={onClick}
        disabled={disabled}
        type={type}
        className="btn-out-section "
      >
        {title}
      </button>
    </div>
  );
}

export default BtnOutline;
